angular.module('FlexyBeautyApp.services')
    .factory('GiftItemEditionType', function () {
        return {
            DELIVERY         : 'delivery',
            DELIVERED        : 'delivered',
            EMAIL            : 'email',
            PRINT_ON_TICKET  : 'printOnTicket',
            MANUAL           : 'manual',
        };
    });


// WEBPACK FOOTER //
// ./js/services/views/ConstantsGiftItemEditionType.js